import React from 'react';
import './Dishatabl.css';



const Dishatabl = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Disha PET preform molding solution</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>
                        Preform Type:</strong> </p>
                    <p><strong>Neck Size:</strong> </p>
                    <p><strong>Weight:</strong> </p>
                    <p><strong>Cycle Time:</strong></p>
                    <p><strong>Machine Model:</strong></p>
                    <p><strong>Capacity:</strong></p>

                </div>
                <div className="right-column">
                    <p>Water Bottle</p>
                    <p>	28mm</p>
                    <p>	20g</p>
                    <p> 18s</p>
                    <p>KPET2100-S6</p>
                    <p>9600 pcs/h</p>

                </div>
            </div>
        </div>
    );
};

export default Dishatabl;
